import React, { useRef, useEffect } from "react";
import AboutTitle from "../../Components/AboutTitle";
import AboutContent from "../../Components/AboutContentBox";
import AOS from "aos";

import Navbar from "../../Components/Navbar";
import SkillsCard from "../../Components/SkillsCard";
import StudyCard from "../../Components/StudyCard";
import RevealComponent from "../../Components/Reveal";
import AboutDbData from "../../DB/About.json"
import Footer from "../../Components/Footer";
import { studyBanner } from "../../Assets/index";
import Loader from "../../Components/Loader";


const Aboutus = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
    console.log(AboutDbData)
  }, []);

  const contentBoxRef = useRef(null);

  const scrollToBottom = () => {
    if (contentBoxRef.current) {
      const { scrollHeight, clientHeight } = contentBoxRef.current;
      const maxScrollTop = scrollHeight - clientHeight;
      contentBoxRef.current.animate(
        { scrollTop: maxScrollTop },
        { duration: 500, easing: "ease-in-out", fill: "both" }
      );
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, []);

  return (
    <>
      <div className="app-main-wrapper about-main-wrapper">
        <Navbar />
        <div className="about-us-main-wrapper-cover mt-lg-5">
          <div className="about-us-section-cover">
            <div className="container">
              <div className="highlight-font-effect">
                <AboutTitle />
              </div>
              <div className="row d-flex">
                <div className="col-lg-1"></div>
                <div className="col-lg-10">
                  <AboutContent contentData = {AboutDbData}/>
                </div>
              </div>
              <div className="myskills-main-wrapper-cover">
                <div className="skills-container-box-wrapper">
                  <h2 className="skills-heading">Proficiencies at a Glance</h2>
                  <SkillsCard />
                  <div className="summary-box my-4">
                    <p>
                      As a frontend developer, I specialize in React.js,
                      JavaScript, HTML, and CSS. I efficiently use Bootstrap for
                      responsive design, jQuery for interactivity, and Git for
                      version control. My skills empower me to create visually
                      appealing and user-friendly web applications.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* <Loader/> */}
            <div className="About-my-studies-main-wrapper">
              <div className="about-my-journey">
                <RevealComponent delay="0.2">
                  <h2 className="text-center">My Studies</h2>
                </RevealComponent>

                <div className="studies-content-wrapper">
                  <div className="row">
                    <div className="col-lg-4">
                      {console.log(AboutDbData.studies[0])}
                      <RevealComponent delay="1.2">
                        <StudyCard  data={AboutDbData.studies[0]}/>
                      </RevealComponent>
                    </div>
                    <div className="col-lg-4">
                      <RevealComponent delay="0.8">
                        <div className="degree-banner-cover">
                          <img src={studyBanner} alt="studies logo"></img>
                        </div>
                      </RevealComponent>
                    </div>
                    <div className="col-lg-4">
                    <RevealComponent delay="1.6">
                      <StudyCard  data={AboutDbData.studies[1]}/>
                    </RevealComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer/>

        </div>
        
      </div>
    </>
  );
};

export default Aboutus;
